import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import "./styles.css";

const systemPrompt = {
    role: "system",
    content: 
    `You are an Islamic scholar and you are employed into an Islamic App "NooriTalk" to chat with its users. Your name is Allama Sufiyan. 
    You should be polite, welcoming, and precise.
    You should talk in whatever language the user has used in his recent messages.
    Users discuss their problems with you or may just randomly talk to you, you should talk to them like a mentor, try to understand them, and solve their problems in the light of Islamic teachings. 
    Tell them Duas, Hadiths, and Quranic solutions to every problem. 
    Always ask them if they are satisfied with the solution and whether they feel good now?
    Make them feel comfortable and understood.
    Decline any haram requests from users.
    If users ask about Gemstones, Islamic Products or Hajj Umrah packages, tell them we have specific sections in NooriTalk app for products and packages.
    
    IMPORTANT:  
    Do respond in human way, and keep your responses precise.`
};

const Chat = () => {
    const [messages, setMessages] = useState([]);
    const [input, setInput] = useState("");
    const [isTyping, setIsTyping] = useState(false);
    const chatEndRef = useRef(null);

    useEffect(() => {
        chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [messages, isTyping]);

    const sendMessage = async () => {
        if (!input.trim()) return;

        const userMessage = { role: "user", content: input };
        const updatedMessages = [...messages, userMessage];

        setMessages(updatedMessages);
        setInput("");
        setIsTyping(true);
        console.log("messages: ", messages);

        try {
            const response = await axios.post(
                "https://api.openai.com/v1/chat/completions",
                {
                    model: "gpt-3.5-turbo",
                    messages: [systemPrompt, ...updatedMessages.slice(-10)],
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${process.env.REACT_APP_OPENAI_API_KEY}`,
                    },
                }
            );

            const reply = {
                role: response.data.choices[0].message.role,
                content: response.data.choices[0].message.content,
            };
            const delay = Math.min(15000, Math.max(5000, reply.content.length * 45));

            setTimeout(() => {
                setMessages(prev => [...prev, reply]);
                setIsTyping(false);
            }, 2); // Delay of 4 seconds
        } catch (error) {
            console.error("OpenAI Error:", error);
            setIsTyping(false);
        }
    };

    return (
        <div className="chat-box">
            <div className="messages">
                {messages.map((msg, idx) => (
                    <div
                        key={idx}
                        className={`message ${msg.role === "user" ? "user" : "bot"}`}
                    >
                        {msg.content}
                    </div>
                ))}
                {isTyping && <div className="typing-indicator">Typing...</div>}
                <div ref={chatEndRef} />
            </div>

            <div className="input-row">
                <input
                    type="text"
                    value={input}
                    onChange={e => setInput(e.target.value)}
                    onKeyDown={(e) => { if (e.key === "Enter") sendMessage(); }}
                    placeholder="Ask your question..."
                />
                <button onClick={sendMessage}>➤</button>
            </div>
        </div>
    );
};

export default Chat;
